import script from "./OptionListEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionListEditor.vue?vue&type=script&setup=true&lang=js"

import "./OptionListEditor.vue?vue&type=style&index=0&id=66a5441e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a5441e"]])

export default __exports__